import { Link } from "react-router-dom";
import { useSuspensePosts, useSuspensePostsLatest } from "../calendar/usePosts";
import { Button } from "../components/Button";
import { Card } from "../components/Card";
import { GenericErrorBoundary } from "../components/GenericError";
import { StatusPlaceholder } from "../components/StatusPlaceholder";
import { LinkGen } from "../LinkGen";
import { Svg } from "../svg";
import { ListEvents } from "./ListEvents";

export function ScheduledCard() {
	return (
		<Card>
			<Card.Header>
				Scheduled Content
				<Link to={LinkGen.Calendar()}>Go to calendar</Link>
			</Card.Header>

			<Card.Body>
				<GenericErrorBoundary>
					<ScheduledBody />
				</GenericErrorBoundary>
			</Card.Body>
		</Card>
	);
}

function ScheduledBody() {
	const latestIDs = useSuspensePostsLatest();
	const latestPosts = useSuspensePosts(latestIDs.IDs);

	if (latestPosts?.length === 0) {
		return (
			<StatusPlaceholder
				label="No upcoming events"
				sublabel="Go to calendar to schedule events"
				image={Svg.WallPost}
			>
				<Button icon="arrow_forward" size="sm">
					Calendar
				</Button>
			</StatusPlaceholder>
		);
	}

	return <ListEvents posts={latestPosts ?? []} />;
}
